import * as React from 'react';
import { api, applyQueryString } from 'services/api';
import type { ScheduledInventoryDataImportListEntry as ListEntry } from 'contracts/scheduled-inventory-data-imports';
import type { Filters } from 'hooks/store/scheduled-inventory-data-imports';

type FetchParams = {
  filters?: Filters;
}

export const useFetchScheduledInventoryDataImports = () => {
  const fetchScheduledImports = React.useCallback(async (params?: FetchParams): Promise<ListEntry[]> => {
    const filters = params?.filters ?? {};
    const preparedFilters = prepareQueryObject(filters);

    const url = applyQueryString(
      '/inventory/scheduled-inventory-data-imports',
      preparedFilters,
    );
    const { data } = await api.get<ListEntry[]>(url);

    return data;
  }, []);

  return {
    fetchScheduledImports,
  };
};

const prepareQueryObject = (filters: Filters) => {
  type MyFilters = Record<string, unknown>;

  Object.entries(filters).forEach(([key, value]) => {
    if (!value || (Array.isArray(value) && !value?.length)) {
      delete (filters as MyFilters)[key];
    }
  });

  return filters;
};